import React from "react";
import "./developAndIntegrate.scss";
import SectionDevelop from "./sections/sectionDevelop";
import ListApiAdvantages from "./sections/listApiAdvantages";
import ListData from "./sections/listData";
import Letsgo from "../connectors/letsgo";
import WantMoreInformationI from './sections/wantMoreInformation'


function DevelopAndIntegrate() {
  return (
    <div className="container-develop-and-integrate">
       <div className="section-develop" >
        <SectionDevelop />
      </div>
      <div className="section-list-api-advantages" >
        <ListApiAdvantages />
      </div>
      <div className="section-list-data">
        <ListData />
      </div>
      <div className="section-letsgo">
        < WantMoreInformationI/>
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  );
}

export default DevelopAndIntegrate;
